import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-547b8f02"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "map-device-wrapper",
  id: "map-deivce-common"
}

import {
  onMounted,
  ref,
  onUnmounted,
} from 'vue'
import { createMap } from '@/utils/map.utils'
import { MAP_TYPE_ENUM } from '@/common'
import L from 'leaflet'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: ['disabledDoubleClick'],
  emits: ['onload', 'on-location-change'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props

const $emit = __emit

let map: any

const timer = ref(100)
onMounted(() => {
  const dom: any = document.getElementById('map-deivce-common')

  timer.value = setInterval(() => {
    if (dom.offsetHeight <= 10) {
      return
    }
    map = createMap('map-deivce-common', {
      tileLayerType: MAP_TYPE_ENUM.STAR,
      zoomControl: true,
      zoom: 4,
    })
    map.doubleClickZoom.disable()

    map.on('dblclick', (event: any) => {
      if (props.disabledDoubleClick) {
        return
      }
      const { lng, lat } = event.latlng
      moveMarker({ lng, lat })
      $emit('on-location-change', { lng: lng.toFixed(6), lat: lat.toFixed(6) })
    })

    $emit('onload')

    clearInterval(timer.value)
  }, 100)
})

onUnmounted(() => {
  clearInterval(timer.value)
})

const marker: any = ref(null)

const createMarker = ({ lng, lat }: any) => {
  const m = L.marker([lat, lng], {
    icon: L.icon({
      iconUrl: require('@/assets/img/map/icon-location.png'),
      iconSize: [44, 61],
      iconAnchor: [22, 63],
    }),
  })
  m.addTo(map)
  marker.value = m

  map.setView([lat, lng])
  return m
}

const moveMarker = ({ lng, lat }: any) => {
  marker.value?.remove?.()
  createMarker({ lng, lat })
}

const removeMarker = () => {
  marker.value?.remove?.()
}

__expose({
  map,
  moveMarker,
  removeMarker,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})